<br>
<!--div class="form-row btntop col-sm-12" style="margin-top: 10px;">
  <table>
    <tr>
      <td>
        <button class="btn border" [disabled]="!toyear" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" [disabled]="!toyear" (click)="clear()">Rensa</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Nya institutioner per år</p>
</div-->



<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" [disabled]="!toyear" (click)="search()">Sök</button>
         <button class="btn border" [disabled]="!toyear" (click)="clear()">Rensa</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Nya institutioner per år</p>

    </div>
  </div>
</div>



<div class="ms-2 me-4">
  <br>
  <div class="row">
    <div class="col-md-1">
      <!--p-dropdown [options]="years" [(ngModel)]="fromyear" placeholder="Från" optionLabel="year" (onChange)="setToYears()" [showClear]="true" [style]="{'min-width':'100px', 'width': '100px'}"></p-dropdown-->
    <p-select [options]="years" [(ngModel)]="fromyear" [checkmark]="true" optionLabel="year" (onChange)="setToYears()" [showClear]="true" placeholder="Från" class="w-full md:w-56" />
    </div>
    <div class="col-md-1">
      <p-select [options]="filteredyears" [(ngModel)]="toyear" [checkmark]="true" [disabled]="!fromyear" placeholder="Till" optionLabel="year" [showClear]="true" class="w-full md:w-56" />
      <!--p-dropdown [options]="filteredyears" [(ngModel)]="toyear" [disabled]="!fromyear" placeholder="Till" optionLabel="year" [showClear]="true" [style]="{'min-width':'100px', 'width': '100px'}"></p-dropdown-->
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-4" style="height:400px;overflow-y:auto;margin-left:20px;">
      <p-menubar *ngIf="list?.length > 0" [model]="items">
      </p-menubar>
      <table *ngIf="list.length > 0">
        <th>År</th>
        <th>Brödraloge</th>
        <th>Brödraläger</th>
        <th>Rebeckaloge</th>
        <th>Rebeckaläger</th>
        <tr *ngFor="let x of list">
          <td align="center">{{x.year}}</td>
          <td align="center" [ngClass]="x.b.length > 0 ? 'link' : 'nolink'" (click)="viewInstitutions(x.year, 'b')">
            {{x.b.length}}</td>
          <td align="center" [ngClass]="x.bl.length > 0 ? 'link' : 'nolink'" (click)="viewInstitutions(x.year, 'bl')">
            {{x.bl.length}}</td>
          <td align="center" [ngClass]="x.r.length > 0 ? 'link' : 'nolink'" (click)="viewInstitutions(x.year, 'r')">
            {{x.r.length}}</td>
          <td align="center" [ngClass]="x.rl.length > 0 ? 'link' : 'nolink'" (click)="viewInstitutions(x.year, 'rl')">
            {{x.rl.length}}</td>
        </tr>
      </table>
    </div>
    <div class="col-md-6">
      <p style="background-color: #F0F0F0;">{{details[0]?.institutionTypeName}}
        {{(details[0]?.startDate).substring(0,4)}}</p>
      <div *ngFor="let d of details">
        <a [routerLink]="['/institutions/id/', d.institutionId]">{{d.shortName}} {{d.institutionName}}</a>
      </div>
    </div>
  </div>